import React, { useCallback, useContext } from 'react';

import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import queryString from 'query-string';

import { ContentContext } from '../../context/ContentContext';
import { PageContext } from '../../context/PageContext';
import { getInternalPath } from '../../utils';

interface Props {
  to: string;
  title?: string;
  role?: string;
  onClick?(): void;
  'aria-current'?:
    | boolean
    | 'false'
    | 'true'
    | 'page'
    | 'step'
    | 'location'
    | 'date'
    | 'time'
    | undefined;
  'data-testid'?: string;
  style?: React.CSSProperties | undefined;
  className?: string;
}

export const InternalLink: React.FC<Props> = ({
  to,
  children,
  onClick,
  ...props
}) => {
  const { pathname } = useLocation();
  const { name } = useContext(PageContext);
  const { handleSettingsClick } = useContext(ContentContext);

  const internalTo = getInternalPath(to, pathname, name);

  const handleClick = useCallback(() => {
    // update the session storage of the content manager
    // if the route contains query params
    if (internalTo.includes('?')) {
      const params = queryString.parse(
        internalTo.replace(/#.*(?=\?)|#.*(?=$)/, '').split('?')[1],
      );
      const values: string[] = Object.values(params).filter(
        (value): value is string => typeof value === 'string',
      );

      handleSettingsClick(values);
    }
    if (onClick) {
      onClick();
    }
  }, [onClick, handleSettingsClick, internalTo]);

  return (
    <Link {...props} to={internalTo} onClick={handleClick}>
      {children}
    </Link>
  );
};
